import api from '@/utils/api';

/**
 * Update Email Template
 * @param {object} templateData - The Email Template data
 * @returns {Promise}
 */
const updateEmailTemplateApi = (templateData) =>
  api.post('/user/my-account/email-template', templateData);

export default updateEmailTemplateApi;
